import { createSelector } from '@reduxjs/toolkit';
import { selectSecurityIncomeState } from '../../store/selectors';

export const selectParameters = createSelector(selectSecurityIncomeState, (listState) => listState.parameters);
export const selectSecurityIncomeSummary = createSelector(selectSecurityIncomeState, (listState) => listState.securityIncomeSummary);
export const selectDividendDistributionsByPaymentDate = createSelector(selectSecurityIncomeState, (listState) => listState.dividendDistributionsByPaymentDate);
